var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1757_6299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4153 1.58974C10.7569 1.63333 10.0802 1.73076 9.55034 1.85641C6.86181 2.4923 4.5169 4.09743 3.00083 6.34102C1.1805 9.03333 0.713619 12.4461 1.74444 15.5026C2.43427 17.541 3.70378 19.2923 5.45591 20.6231C7.44673 22.1359 10.088 22.9385 12.6192 22.8C14.1772 22.7154 15.4913 22.3795 16.871 21.7179C18.0094 21.1718 18.9064 20.5385 19.8008 19.6513C20.4828 18.9718 20.9339 18.4026 21.4218 17.6026C23.2998 14.5231 23.4389 10.6487 21.7864 7.4282C21.0703 6.03846 20.029 4.7923 18.7595 3.81794C17.3274 2.71538 15.4913 1.94102 13.7261 1.6923C12.9759 1.58461 12.0815 1.54615 11.4153 1.58974ZM12.648 3.13076C14.9431 3.27692 17.0153 4.18974 18.6257 5.75897C20.7294 7.81025 21.6972 10.6692 21.2618 13.5385C20.8107 16.4974 18.8723 19.0692 16.1103 20.3718C12.9235 21.8744 9.16739 21.4872 6.37395 19.3667C3.66968 17.3154 2.34247 13.9872 2.90641 10.6795C3.20018 8.95897 4.02903 7.30769 5.23034 6.04871C6.36345 4.86153 7.68542 4.03076 9.19362 3.55384C10.353 3.18974 11.4651 3.05384 12.648 3.13076Z",
    fill: "#F44336",
    stroke: "#F44336",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8873 7.50514C11.6644 7.56411 11.4414 7.75129 11.3496 7.95898C11.3024 8.06155 11.2998 8.17949 11.2946 10.2103L11.2893 12.3513L11.3549 12.4898C11.4467 12.6872 11.5385 12.7795 11.7221 12.8692C12.1339 13.0718 12.648 12.8769 12.8054 12.459C12.8552 12.3256 12.8552 12.2564 12.8473 10.1923L12.8395 8.06411L12.7818 7.9359C12.7057 7.77693 12.5536 7.62565 12.3988 7.55642C12.2834 7.50514 11.9923 7.47693 11.8873 7.50514Z",
    fill: "#F44336",
    stroke: "#F44336",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8664 15.3948C11.6933 15.4436 11.5464 15.5436 11.4467 15.682C11.3313 15.8436 11.3025 15.9333 11.2998 16.141C11.2972 16.4384 11.452 16.6795 11.7352 16.823C11.8402 16.8743 11.8979 16.8846 12.0841 16.8846C12.328 16.882 12.4067 16.8538 12.6008 16.7025C12.9313 16.4384 12.9471 15.9 12.6297 15.5923C12.4408 15.4077 12.1182 15.3256 11.8664 15.3948Z",
    fill: "#F44336",
    stroke: "#F44336",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1757_6299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.76673d328540c260a995da4685673933.svg";
export { ForwardRef as ReactComponent };